export const BlueCircle = () => {
  return (
    <svg
      className="top-left-blue-circle-1"
      viewBox="0 0 100 100"
      width="200"
      height="200"
    >
      <circle
        cx="50"
        cy="50"
        r="40"
        fill="none"
        stroke="#364ded"
        strokeWidth={10}
      />
    </svg>
  );
};

export const PurpleDiamond = () => {
  return (
    <svg
      className="top-right-purple-diamon-1"
      viewBox="0 0 200 200"
      width="200"
      height="200"
    >
      <path d="m74-584.5l352.4-352.5 352.5 352.5z" fill="#824ef0" />
      <path d="m2.7 97.7l94.6-94.7 94.7 94.7-94.7 94.6z" fill="#824ef0" />
    </svg>
  );
};

export const MiniGreenTriangle = () => {
  /* 824ef0 99dbef 1fa089 ef4a42  */
  return (
    <svg
      className="top-left-green-triangle-1"
      viewBox="0 0 86 70"
      width="86"
      height="70"
    >
      <path
        d="M63.3118 40.5751L41.2974 25.7948L26.5255 47.7966L63.3118 40.5751Z"
        fill="#1FA089"
      />
    </svg>
  );
};

export const MiniOrangeTriangle = () => {
  /* 824ef0 99dbef 1fa089 ef4a42  */
  return (
    <svg
      className="top-right-orange-triangle-1"
      width="86"
      height="70"
      viewBox="0 0 86 70"
    >
      <path
        d="M63.3118 40.5751L41.2974 25.7948L26.5255 47.7966L63.3118 40.5751Z"
        fill="#ef4a42"
      />
    </svg>
  );
};

export const PurpleTriangle = () => {
  /* 824ef0 99dbef 1fa089 ef4a42  */
  return (
    <svg
      className="bottom-left-ourple-triangle-1"
      viewBox="0 0 300 300"
      width="300"
      height="300"
    >
      <path d="m10.5 290.6v-280.5l280.4 280.5z" fill="#364ded" />
    </svg>
  );
};

export const MiniAquaSquare = () => {
  /* 824ef0 99dbef 1fa089 ef4a42  */
  return (
    <svg
      className="bottom-left-aqua-square-1"
      width="60"
      height="60"
      viewBox="0 0 60 60"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.8137 20.9915L22.2917 43.54L44.8402 37.0619L38.3621 14.5135L15.8137 20.9915Z"
        fill="#99DBEF"
      />
    </svg>
  );
};

export const MiniYellowSquare = () => {
  /* 824ef0 99dbef 1fa089 ef4a42  */
  return (
    <svg
      className="top-right-yellow-square-1"
      viewBox="0 0 60 60"
      width="60"
      height="60"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="m10 290.5v-280.4h280v280.4z"
        fill="#f8af3b"
      />
    </svg>
  );
};

export const GreenSquare = () => {
  /* 824ef0 99dbef 1fa089 ef4a42  */
  return (
    <svg
      className="top-right-green-square-1"
      viewBox="0 0 60 60"
      width="60"
      height="60"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="m10 290.5v-280.4h280v280.4z"
        fill="none"
        stroke="#1FA089"
        strokeWidth={10}
      />
    </svg>
  );
};
